// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset 'UTF-8';
.slick-dots,
.slick-next,
.slick-prev {
  position: absolute;
  display: block;
  padding: 0;
}
.slick-dots li button:before,
.slick-next:before,
.slick-prev:before {
  font-family: slick;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.slick-next,
.slick-prev {
  font-size: 0;
  line-height: 0;
  top: 50%;
  width: 20px;
  height: 20px;
  transform: translate(0, -50%);
  cursor: pointer;
  color: transparent;
  border: none;
  outline: 0;
  background: 0 0;
}
.slick-next:focus,
.slick-next:hover,
.slick-prev:focus,
.slick-prev:hover {
  outline: 0;
  background: 0 0;
}
.slick-next:focus:before,
.slick-next:hover:before,
.slick-prev:focus:before,
.slick-prev:hover:before {
  opacity: 1;
}
.slick-next.slick-disabled:before,
.slick-prev.slick-disabled:before {
  opacity: 0.25;
}
.slick-next:before,
.slick-prev:before {
  font-size: 20px;
  line-height: 1;
  opacity: 0.75;
}
.slick-prev {
  left: -25px;
}
[dir='rtl'] .slick-prev {
  right: -25px;
  left: auto;
}
.slick-prev:before {
  content: '←';
}
.slick-next:before,
[dir='rtl'] .slick-prev:before {
  content: '→';
}
.slick-next {
  right: -25px;
}
[dir='rtl'] .slick-next {
  right: auto;
  left: -25px;
}
[dir='rtl'] .slick-next:before {
  content: '←';
}
.slick-dotted.slick-slider {
  margin-bottom: 30px;
}
.slick-dots {
  bottom: 10%;
  width: 100%;
  margin: 0;
  list-style: none;
  text-align: center;
}
.slick-dots li {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
}
.slick-dots li button {
  font-size: 0;
  line-height: 0;
  display: block;
  width: 20px;
  height: 20px;
  padding: 5px;
  cursor: pointer;
  color: transparent;
  border: 0;
  outline: 0;
  background: 0 0;
}
.slick-dots li button:focus,
.slick-dots li button:hover {
  outline: 0;
}
.slick-dots li button:focus:before,
.slick-dots li button:hover:before {
  opacity: 1;
}
.slick-dots li button:before {
  font-size: 6px;
  line-height: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  content: '•';
  text-align: center;
  opacity: 0.25;
  color: #000;
}
.slick-dots li.slick-active button:before {
  opacity: 0.75;
  color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/login/carousel/slick-theme.min.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;EAGE,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;AACA;;;EAGE,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;AACpC;AACA;;EAEE,YAAY;EACZ,cAAc;EACd,QAAQ;EACR,WAAW;EACX,YAAY;EAGZ,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;AACA;;;;EAIE,UAAU;EACV,eAAe;AACjB;AACA;;;;EAIE,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,eAAe;EACf,cAAc;EACd,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;;EAEE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;EACV,eAAe;AACjB;AACA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;AACb","sourcesContent":["@charset 'UTF-8';\n.slick-dots,\n.slick-next,\n.slick-prev {\n  position: absolute;\n  display: block;\n  padding: 0;\n}\n.slick-dots li button:before,\n.slick-next:before,\n.slick-prev:before {\n  font-family: slick;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.slick-next,\n.slick-prev {\n  font-size: 0;\n  line-height: 0;\n  top: 50%;\n  width: 20px;\n  height: 20px;\n  -webkit-transform: translate(0, -50%);\n  -ms-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  cursor: pointer;\n  color: transparent;\n  border: none;\n  outline: 0;\n  background: 0 0;\n}\n.slick-next:focus,\n.slick-next:hover,\n.slick-prev:focus,\n.slick-prev:hover {\n  outline: 0;\n  background: 0 0;\n}\n.slick-next:focus:before,\n.slick-next:hover:before,\n.slick-prev:focus:before,\n.slick-prev:hover:before {\n  opacity: 1;\n}\n.slick-next.slick-disabled:before,\n.slick-prev.slick-disabled:before {\n  opacity: 0.25;\n}\n.slick-next:before,\n.slick-prev:before {\n  font-size: 20px;\n  line-height: 1;\n  opacity: 0.75;\n}\n.slick-prev {\n  left: -25px;\n}\n[dir='rtl'] .slick-prev {\n  right: -25px;\n  left: auto;\n}\n.slick-prev:before {\n  content: '←';\n}\n.slick-next:before,\n[dir='rtl'] .slick-prev:before {\n  content: '→';\n}\n.slick-next {\n  right: -25px;\n}\n[dir='rtl'] .slick-next {\n  right: auto;\n  left: -25px;\n}\n[dir='rtl'] .slick-next:before {\n  content: '←';\n}\n.slick-dotted.slick-slider {\n  margin-bottom: 30px;\n}\n.slick-dots {\n  bottom: 10%;\n  width: 100%;\n  margin: 0;\n  list-style: none;\n  text-align: center;\n}\n.slick-dots li {\n  position: relative;\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  margin: 0 5px;\n  padding: 0;\n  cursor: pointer;\n}\n.slick-dots li button {\n  font-size: 0;\n  line-height: 0;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 5px;\n  cursor: pointer;\n  color: transparent;\n  border: 0;\n  outline: 0;\n  background: 0 0;\n}\n.slick-dots li button:focus,\n.slick-dots li button:hover {\n  outline: 0;\n}\n.slick-dots li button:focus:before,\n.slick-dots li button:hover:before {\n  opacity: 1;\n}\n.slick-dots li button:before {\n  font-size: 6px;\n  line-height: 20px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  content: '•';\n  text-align: center;\n  opacity: 0.25;\n  color: #000;\n}\n.slick-dots li.slick-active button:before {\n  opacity: 0.75;\n  color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
